import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/academy-frontend/src/components/pages/home/courses/CourseAll.js");
